<!-- 人才赋能 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_team.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="人才赋能" en="TALENT EMPOWERMENT"></sub-title>
      </div>
      <div :class="{ box: true, active }">
        <div class="list w1200">
          <div class="item">
            <div class="title">远智百年</div>
            <div class="info">
              企业战略、文化体系、组织体系、人才体系、激励体系、产品体系、运营体系咨询，持续陪跑企业成长，助力企业健康发展
            </div>
          </div>
          <div class="item">
            <div class="title">华一集团</div>
            <div class="info">
              薪酬绩效机制、股权激励机制、合伙人机制咨询服务
            </div>
          </div>
          <div class="item">
            <div class="title">宏成咨询</div>
            <div class="info">薪酬绩效机制、合伙人机制咨询</div>
          </div>
          <div class="item">
            <div class="title">中慧世纪</div>
            <div class="info">企业商业模式设计及咨询</div>
          </div>
          <div class="item">
            <div class="title">金财控股</div>
            <div class="info">企业财税咨询</div>
          </div>
          <div class="item">
            <div class="title">行业专家</div>
            <div class="info">专业技术顾问咨询</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      active: false, // 动画激活状态
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {
    setTimeout(() => {
      this.active = true;
    }, 500);
  },
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/organization_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
  }
  .box {
    height: 31vw;
    margin-bottom: 120px;
    background-image: url("http://api.zyzxgc.cn/file/static/empowerment_bg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position-x: -100vw;
    transition: 0.5s;

    .list {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .item {
        flex: 1;
        display: flex;
        align-items: center;
        transform: translateX(-100vw);
        transition: 0.5s;

        &:nth-child(1) {
          transition-delay: 0.5s;
        }
        &:nth-child(2) {
          transition-delay: 0.7s;
        }
        &:nth-child(3) {
          transition-delay: 0.9s;
        }
        &:nth-child(4) {
          transition-delay: 1.1s;
        }
        &:nth-child(5) {
          transition-delay: 1.3s;
        }
        &:nth-child(6) {
          transition-delay: 1.5s;
        }

        &:nth-child(2n) {
          .title {
            color: $theme;
          }
          .info {
            color: $theme;
          }
        }

        .title {
          font-size: 30px;
          color: #ffffff;
        }
        .info {
          width: 550px;
          font-size: 18px;
          color: #ffffff;
          line-height: 42px;
          margin-left: 100px;
        }
      }
    }
  }
  .active {
    background-position-x: 0;

    .list .item {
      transform: translateX(0);
    }
  }
}

@media (max-width: 1500px) {
  .frame .box .list .item {
    .title {
      font-size: 25px;
    }
    .info {
      line-height: 1.2;
      font-size: 16px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
    }
    .box {
      height: 50vh;
      padding: 0 10px;
      margin-bottom: 20px;
      background-position-x: -217vw;

      .list .item {
        .title {
          font-size: 14px;
          flex-shrink: 0;
        }
        .info {
          width: auto;
          font-size: 12px;
          flex-grow: 1;
          margin-left: 10px;
        }
      }
    }
    .active {
      background-position-x: -100vw;
    }
  }
}
</style>
